export default __webpack_public_path__ + "static/media/webDesign.b4e417e3.png";